<template>
  <div id="app-home">
    <!-- <div class="top">
      <dl>
        <dt class="topDt">
          <img :src="userInfo.avatar" alt="" />
        </dt>
        <dd>
          <p>
            {{ userInfo.name }}
          </p>
          <span>您入职{{ userInfo.joindays }}天啦！</span>
        </dd>
      </dl>
      <div>
        <img src="@/assets/translate.svg" alt="" @click="$router.push(`/mobile/card?workcode=${empNo}`)"
          class="slateImg" />
      </div>
    </div>
    <div class="content">
      <div class="conImg">
        <img src="@/assets/home.png" alt="" />
      </div>
      <div class="conBox">
        <div class="conBox_one" v-for="item in list" :key="item.key" @click="toPath(item)">
          <div class="conBox_two" v-if="item.show">
            <div class="conBox_three">
              <div class="conBox_four">
                <img :src="item.img" alt="" class="conBoxImg bigImg" />
              </div>
              <div class="conBox_five">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="top1">
      <!-- <img class="imgBac" src="../../assets/home/topBackground.png" alt=""> -->
      <div class="title">员工自助</div>
      <dl class="topCon">
        <dt class="topDt">
          <img :src="userInfo.avatar" alt="" />
        </dt>
        <dd>
          <p>
            {{ userInfo.name }}
          </p>
          <div class="num">您入职{{ userInfo.joindays }}天啦！</div>
          <div>
            <img src="@/assets/home/card.png" alt="" @click="$router.push(`/mobile/card?workcode=${empNo}`)"
              class="slateImg" />
          </div>
        </dd>
      </dl>

    </div>
    <!-- <div class="content1">
      <div class="contentCon">
        <div class="left" @click="toMyInfo">
          <div>我的信息</div>
        </div>
        <div class="right">
          <div class="top" @click="toSalary">
            <div>我的工资单</div>
          </div>
          <div class="bottom" @click="toClock">
            <div>我的考勤</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="contentBottomCon">
      <div class="bottomItem" v-for="(item, index) in list" :key="index" @click="toPath(item)">
        <div class="itemCon" v-if="item.show">
          <div class="left">
            <img :src="item.img" alt="">
            <div class="leftTit">{{ item.value }}</div>
          </div>
          <div class="right">
            <img src="@/assets/home/right.png" alt="">
          </div>
        </div>

      </div>
    </div>
    <div class="footer" v-if="showInsuranceInfo">
      <van-popover v-model="showPopover" trigger="click" placement="left">
        <div style="padding: 10px;" class="footerCon">

          <van-uploader :max-count="1" :after-read="afterTwo" class="btn importBtn"
            accept=".xlsx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            :max-size="20480 * 1024">
            <div v-if="showImport"
              style="cursor: pointer;display: flex;align-items: center;line-height: 35px;font-size: 15px;">
              <img src="@/assets/insurance/baoDanDaoRu.png" alt=""
                style="width: 20px;height: 20px;margin-right: 10px;" />保单信息导入
            </div>
          </van-uploader>
          <div v-if="showInsuranceQuery" @click="setPushTwo"
            style="cursor: pointer;display: flex;align-items: center;line-height: 35px;font-size: 15px;">
            <img src="@/assets/insurance/shangBaoSouSuo.png" alt=""
              style="width: 20px;height: 20px;margin-right: 10px;" />商保填报查询
          </div>
          <div v-if="showInsuranceChange" @click="setPushThree"
            style="cursor: pointer;display: flex;align-items: center;line-height: 35px;font-size: 15px;">
            <img src="@/assets/insurance/shangBaoGengXin.png" alt=""
              style="width: 20px;height: 20px;margin-right: 10px;" />商保信息变更
          </div>
          <div v-loading="exportBtnLoading" v-if="showExport" @click="setPushFour"
            style="cursor: pointer;display: flex;align-items: center;line-height: 35px;font-size: 15px;">
            <img src="@/assets/insurance/shangBaoDaoChu.png" alt=""
              style="width: 20px;height: 20px;margin-right: 10px;" />商保填报信息导出
          </div>
          <div v-if="showSetPushTime" @click="setPushFive"
            style="cursor: pointer;display: flex;align-items: center;line-height: 35px;font-size: 15px;">
            <img src="@/assets/insurance/date.svg" alt=""
              style="width: 22px;height: 23px;margin-right: 7px;" />(统一)推送时间设置
          </div>
        </div>
        <template #reference>
          <img src="@/assets/home/more.png" alt="" @click="setSelect" />
        </template>
      </van-popover>

    </div>

  </div>
</template>

<script>
// import insurance from "@/assets/insurance/insurance.png";
import baodan from "@/assets/home/baodan.png";
import shangbao from "@/assets/home/shangbao.png";
import shenbao from "@/assets/home/shenbao.png";
import api from "@/apis";
import apis from "@/apis/insurance.js";
import DeviceDetector from "device-detector-js";
import { setDevice } from "@/utils/cookie";
// import moment from "moment";
import { getToken } from "@/utils/cookie";
import utils from '@/utils/utils';
import apiLogin from "@/apis";
export default {
  name: "insuranceHome",
  data() {
    return {
      info: {},
      empNo: "",
      userInfo: {},
      showSend: true,
      select: false,
      visibleBonus: false,
      visibleSalary: false,
      tableBonus: [],
      tableSalary: [],
      list: [],
      value: "",
      totalBonus: 0,
      totalSalary: 0,
      showAuthImg: false,
      showAuthAttendance: false,
      showAuthPay: false,
      showAuthBonus: false,
      showAuthSalary: false,
      showAuthAchievements: false,
      showAuthVacation: false,
      showPopover: false,
      ismobile: utils.parseUA().mobile,
      fileListTwo: [],
      showInsuranceInfo: false, // HR更多图标
      showImport: false, // 保单导入
      showInsuranceQuery: false, //商保查询
      showInsuranceChange: false,//商保变更
      showExport: false,//商保导出
      showSetPushTime: true,//设置推送时间
      showDeclare: false,
      exportBtnLoading: false
    };
  },
  created() {
    this.queryUser();
  },
  mounted() {
    let token = getToken();
    if (token) {
      this.empNo = token;
      this.getUserinfo();
      this.sendAuth();
      this.redirectRoute();
    }
    // let token1 = window.sessionStorage.hrToken;
    if (token) {
      this.queryUser();
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.queryUser();
        });
      });
    }
  },
  methods: {
    // 获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 获取用户信息，判断是否有申报权限
    queryUser() {
      console.log('getToken()',getToken());
      apis.queryByUsernames({ username: getToken() }).then(res => {
        if (res.code == 200) {
          // this.getHrToken(window.sessionStorage.empNo);
          this.showDeclare = res.data.isDeclare == 1 ? false : true;
          this.list = [
            {
              img: shenbao,
              value: "关联子女申报",
              key: "1",
              path: "/declare?isEdit=false",
              show: true
            },
            {
              img: baodan,
              value: "保单信息",
              key: "2",
              path: "/policy",
              show: true
            },
            {
              img: shangbao,
              value: "关联子女申报记录查询",
              key: "3",
              path: "/commercialQuery",
              show: true
            },

          ];
          if (this.showDeclare == false) {

            this.list.shift();
          }
        }
      });
    },
    // 获取用户信息
    getUserToken(empNo) {
      if (empNo) {
        let thisname = empNo;
        if (
          thisname === "17625010228" ||
          thisname === "15093054787" ||
          thisname === "17637403245"
        ) {
          thisname = "10005038";
        }

        api.getUserToken({ username: thisname }).then((data) => {
          console.log(data);
          const info = data.data;
          localStorage.setItem("salaryPhone", info.mobileNo);
          localStorage.setItem("salaryInfo", JSON.stringify(info));

          window.sessionStorage.hrToken = info.auth_token;
          this.$store.commit("changeUserInfo", info);

          this.empNo = empNo;
          this.getUserinfo();
          this.sendAuth();
          this.redirectRoute();
        });
      }
    },
    //获取权限
    sendAuth() {
      api.getSelectPermission({ empNo: this.empNo }).then((data) => {
        const items = data.data;
        // console.log(items);
        items.forEach((item) => {

          if (item.permission === "901") {
            this.showInsuranceInfo = true;
          } else if (item.permission === "902") {
            this.showImport = true;
          } else if (item.permission === "903") {
            this.showInsuranceQuery = true;
          } else if (item.permission === "904") {
            this.showInsuranceChange = true;
          } else if (item.permission === "905") {
            this.showExport = true;
          } else if (item.permission === "906") {
            this.showSetPushTime = true;
          }
        });
      });
    },
    //跳转
    toPath(item) {
      if (item.key !== "6") {
        this.$router.push(item.path);
      } else {
        window.open(
          "https://wx.helianwap.com/mobile/enterprise-space.html",
          "_blank"
        );
      }
    },
    // 获取用户信息
    getUserinfo() {
      api.getUserinfo().then((res) => {
        this.userInfo = res.data;
      });
    },
    //判断是否是手机端
    redirectRoute() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];

      const deviceDetector = new DeviceDetector();
      let device = deviceDetector.parse(userAgentInfo);
      setDevice(
        device.device.brand + " " + device.os.name + " " + device.client.name
      );

      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.showSend = false;
          break;
        }
      }
    },
    setSelect() {
      if (this.select === false) {
        this.select = true;
      } else {
        this.select = false;
      }
    },
    // 导入
    afterTwo(file) {
      if (this.fileListTwo.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个excel",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        console.log('params11111', params);
        this.fileListTwo.push({ name: file.file.name });
        // this.flagExcel = true;
        apis.importPolicy({ file: params }).then(data => {
          if (data.code == 200) {
            this.fileListTwo = [];
            this.$message({
              message: "导入成功",
              type: "success"
            });
          }
        }).catch(() => {
          this.fileListTwo = [];
        });
      }
    },
    //跳转
    setPushTwo() {
      console.log('utils.parseUA().mobile', utils.parseUA().mobile);
      // this.$router.push({ path: "/commercialFill" });
      if (this.ismobile) {
        this.$router.replace({ path: "/commercialFill" });
      } else {
        this.$router.replace({ path: "/commercialFillPC" });
      }
    },
    //跳转
    setPushThree() {
      this.$router.replace({ path: "/declare?isEdit=true" });
    },
    //导出
    setPushFour() {
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        page: 1,
        pageSize: 3000
      };
      this.exportBtnLoading = true;
      apis.exportEmployeeChild(json).then(res => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `员工子女.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.exportBtnLoading = false;
      }).catch(() => {
        this.exportBtnLoading = false;
      });
    },
    //跳转
    setPushFive() {
      this.$router.replace({ path: "/pushDate" });
    }
  },
};
</script>


<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}

#app-home {
  font-size: 16px * $zoom;
  position: relative;
  display: flex;
  justify-content: center;

  &::v-deep .send-btn {
    width: 130px;
    height: 130px;
    overflow: auto;
    border-radius: 0;

    .img-box {
      box-shadow: none;
      background-size: contain;
      border-radius: 0;
    }
  }
}

// .top {
//   width: 100%;
//   height: 72pt;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 0 10px * $zoom;

//   .slateImg {
//     width: 24pt;
//   }

//   dl {
//     display: flex;
//     align-items: center;

//     .topDt {
//       img {
//         width: 46pt;
//         border-radius: 50%;
//         margin-right: 10px * $zoom;
//       }
//     }

//     dd {
//       font-size: 18pt;

//       // line-height: 25px * $zoom;
//       // font-weight: 600;
//       span {
//         font-size: 12pt;
//         font-weight: normal;
//       }
//     }
//   }
// }

// .content {
//   width: 100%;
//   flex: 1;

//   .conImg {
//     width: 100%;
//     height: 30%;

//     img {
//       width: 100%;
//     }
//   }

//   .conBox {
//     width: 90%;
//     // height: 200px * $zoom;
//     background: #fff;
//     border-radius: 20px * $zoom;
//     position: absolute;
//     left: 5%;
//     top: 85%;
//     box-shadow: 0px 10px 15px 5px #f4f4f4;
//     display: flex;
//     flex-wrap: wrap;

//     div:nth-child(3) {
//       .conBox_three {
//         border-right: none;
//       }
//     }

//     div:nth-child(6) {
//       .conBox_three {
//         border-right: none;
//       }
//     }

//     .conBox_one {
//       width: 33.3%;

//     }

//     .conBoxImg {
//       width: 32px * $zoom;
//       height: 32px * $zoom;
//     }

//     .bigImg {
//       transform: scale(1.5);
//     }

//     .conBox_three {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       flex-direction: column;
//       border-bottom: 1px solid #f4f4f4;
//       border-right: 1px solid #f4f4f4;
//       padding: 20px * $zoom 0;

//       .conBox_five {
//         font-size: 12pt;
//       }
//     }
//   }
// }
.top1 {
  width: 100%;
  height: 218pt;
  // height: 772px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 0 10px * $zoom;
  background-image: url('../../../assets/home/topBackground.png');
  background-size: 100% 100%;
  position: relative;

  .title {
    font-size: 14pt;
    color: #fff;
    position: absolute;
    top: 12%;
    right: 40%;
  }

  .imgBac {
    width: 100%;
    height: 100%;
  }

  .slateImg {
    width: 20pt;
  }

  .topCon {
    position: absolute;
    top: 28%;
    left: 7%;
    display: flex;
    // align-items: center;

    .topDt {
      img {
        width: 41pt;
        border-radius: 50%;
        margin-right: 10px * $zoom;
      }
    }

    p {
      font-size: 32px;
    }

    dd {
      font-size: 14pt;
      color: #FFFFFF;

      // line-height: 25px * $zoom;
      // font-weight: 600;
      .num {
        font-size: 10pt;
        font-weight: normal;
        margin: 10px 0 15px 0;
      }
    }
  }
}

.content1 {
  position: absolute;
  top: 135pt;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  // height: 100%;

  .contentCon {
    width: 92%;
    height: 158pt;
    padding: 28px 30px;
    background-image: url('../../../assets/home/conBackground.png');
    background-size: 100% 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;

    .left {
      width: 48%;
      background-image: url('../../../assets/home/info.png');
      background-size: 100% 100%;
      position: relative;

      div {
        font-size: 10pt;
        position: absolute;
        left: 10pt;
        top: 20pt;
        color: #2EA355;
        font-weight: 550;
      }
    }

    .right {
      width: 48%;
      height: 100%;
      display: flex;
      align-content: center;
      justify-content: space-between;
      flex-direction: column;

      .top {
        height: 48%;
        background-image: url('../../../assets/home/gongzidan.png');
        background-size: 100% 100%;
        position: relative;

        div {
          font-size: 10pt;
          color: #FF9600;
          font-weight: 550;
          display: flex;
          align-content: center;
          position: absolute;
          left: 10pt;
          top: 40%;
        }
      }

      .bottom {
        height: 48%;
        background-image: url('../../../assets/home/kaoqin.png');
        background-size: 100% 100%;
        position: relative;

        div {
          font-size: 10pt;
          color: #7E6DE8;
          font-weight: 550;
          display: flex;
          align-content: center;
          position: absolute;
          left: 10pt;
          top: 40%;
        }
      }
    }
  }


}

.contentBottomCon {
  position: absolute;
  top: 146pt;
  width: 91%;
  border-radius: 10px;
  background-color: #fff;

  // margin: 0 30px;
  .bottomItem:last-child {
    .itemCon {
      border: 0;
    }
  }

  .bottomItem {
    width: 100%;

    .itemCon {
      display: flex;
      justify-content: space-between;
      align-content: center;
      flex-wrap: wrap-reverse;
      height: 40pt;
      margin: 0 30px;
      padding: 0 30px;
      border-bottom: 1px solid #EBEDF2;
      background-color: #fff;

      .itemCon:last-child {
        border-bottom: 0;
        border-radius: 0 0 10px 10px;
      }

      .itemCon:first-child {
        border-radius: 10px 10px 0 0;
      }

    }


    .left {
      display: flex;
      align-content: center;

      img {
        width: 23pt;
        height: 23pt;
      }

      .leftTit {
        font-size: 11.5pt;
        line-height: 23pt;
        margin-left: 11pt;
      }
    }

    .right {
      img {
        width: 7pt;
        height: 11pt;
      }
    }
  }
}

.footer {
  position: absolute;
  top: 170%;
  right: 1%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  img {
    width: 42px * $zoom;
    cursor: pointer;
  }

  .footerImg {
    img {
      width: 55px * $zoom;
      cursor: pointer;
    }
  }

  &>div {
    border: 1px solid #f6f6f6;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
    font-size: 26px;

    div {
      padding: 20px 40px;
      color: #6d6c6c;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        width: 35px;
        margin-right: 10px;
      }

      .img {
        width: 30px;
        margin-left: 5px;
      }
    }
  }
}

.tableBonus {
  ::v-deep .has-gutter {
    .cell {
      color: #fff;
    }
  }

  ::v-deep .cell {
    line-height: 55px;
    text-align: center;
  }

  ::v-deep th.el-table__cell {
    background-color: #499f6d;
  }

  ::v-deep .el-table_1_column_6 {
    background-color: #db9141 !important;
  }

  ::v-deep .el-table_1_column_8 {
    background-color: #db9141 !important;
  }

  ::v-deep .el-table_1_column_10 {
    background-color: #db9141 !important;
  }
}

.tableSalary {
  ::v-deep .has-gutter {
    .cell {
      color: #fff;
    }
  }

  ::v-deep .cell {
    line-height: 55px;
    text-align: center;
  }

  ::v-deep th.el-table__cell {
    background-color: #499f6d;
  }
}

.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
}

.footBtn {
  margin-top: 40px;
  display: flex;
  justify-content: center;

  .el-button {
    width: 200px;
    height: 60px;
    margin-right: 40px;
    font-size: 16px;
  }
}

::v-deep .el-dialog__body {
  max-height: 1200px !important;
  overflow-y: scroll;
}
</style>
